module.exports = __webpack_public_path__ + "static/media/splash3_3x.787411b8.jpg";